import module_8a229920e289498fa758f5747c55dbc5 from 'nanogl-pbr/glsl/includes/glsl-compat.frag'
var fn = function( obj ){
var __t,__p='';
__p+=''+
(obj.version)+
'\n\n#if __VERSION__ != 300\n  #extension GL_OES_standard_derivatives : enable\n#endif \n\nprecision '+
(obj.highp)+
' float;\n\n\n'+
(module_8a229920e289498fa758f5747c55dbc5())+
'\n\n\nuniform vec3 uColor;\n\nconst float N = 150.0; // grid ratio\n\nfloat gridTextureGradBox( in vec2 p, in vec2 ddx, in vec2 ddy, float thickness )\n{\n	// filter kernel\n    vec2 w = max(abs(ddx), abs(ddy)) + 0.0001;\n\n    // float n = N;\n    float n = thickness;//.2/(min(length(ddx), length(ddy)));\n\n	// analytic (box) filtering\n    vec2 a = p + 0.5*w;                        \n    vec2 b = p - 0.5*w;           \n    vec2 i = (floor(a)+min(fract(a)*n,1.0)-\n              floor(b)-min(fract(b)*n,1.0))/(n*w);\n    //pattern\n    return (1.0-i.x)*(1.0-i.y);\n}\n\nIN vec2 vTexCoord;\n\nvoid main(void){\n  		\n  vec2 ddx_uv = dFdx( vTexCoord ); \n  vec2 ddy_uv = dFdy( vTexCoord ); \n\n  float grid = \n    gridTextureGradBox( vTexCoord, ddx_uv, ddy_uv, N ) *\n    gridTextureGradBox( vTexCoord*10.0, ddx_uv*10.0, ddy_uv*10.0, N )*\n    gridTextureGradBox( vTexCoord/10.0, ddx_uv/10.0, ddy_uv/10.0, N*3.0 );\n    // *gridTextureGradBox( vTexCoord*100.0, ddx_uv*100.0, ddy_uv*100.0 );\n\n  FragColor = vec4( uColor, 1.0-grid );\n  // FragColor = vec4( vec3(grid), 1.0 );\n}';
return __p;
};
fn.toString=fn;
export default fn;
fn._hmrListeners = []
fn.onHmr = function(l){
  this._hmrListeners.push( l )
}
fn._triggerHmr = function(){
  for (const l of this._hmrListeners) {
    l( this )
  }
}

if( import.meta.hot ){
  if( import.meta.hot.data && import.meta.hot.data._hmrListeners ){
    fn._hmrListeners = import.meta.hot.data._hmrListeners;
    fn._triggerHmr()
  }
  
  import.meta.hot.dispose(data => {
    data._hmrListeners = fn._hmrListeners;
  });
  
  import.meta.hot.accept(
    function(e){} // Function to handle errors when evaluating the new version
  );
}
